import axios from "axios";
import parser from "xml-js";

const getCodigoEAN = async (pesquisa) => {
  let returnResponse = null;
  try {
    let query = `?codigogrupo=${pesquisa.CODIGO_GRUPO._text}&concorrente=${pesquisa.CONCORRENTE._text}&ean=${pesquisa.EAN11._text}&werks=${pesquisa.WERKS._text}`;
    let response = await axios.get(
      window.url_api + "/app/zws_app_buscar_matnr_ean" + query
    );
    response = parser.xml2json(response.data, { compact: true, spaces: 4 });
    response = JSON.parse(response);

    if (
      response["soap-env:Envelope"]["soap-env:Body"][
      "n0:ZMM_WS_APP_BUSCAR_MATNR_EANResponse"
      ]
    ) {
      let _returnResponse =
        response["soap-env:Envelope"]["soap-env:Body"][
        "n0:ZMM_WS_APP_BUSCAR_MATNR_EANResponse"
        ];

      if (
        _returnResponse.S_CADASTRAR_PESQUISA &&
        _returnResponse.S_CADASTRAR_PESQUISA.CODIGO_GRUPO
      ) {
        let _prDif = null

        try {
          _prDif = parseFloat(_returnResponse.S_CADASTRAR_PESQUISA.PR_DIF._text)
        }
        catch (e) {
          console.error(e)
          _prDif = { _text: _returnResponse.S_CADASTRAR_PESQUISA.PR_DIF._text }
        }
        
        returnResponse = {
          CODIGO_GRUPO: { _text: _returnResponse.S_CADASTRAR_PESQUISA.CODIGO_GRUPO._text },
          CONCORRENTE: { _text: _returnResponse.S_CADASTRAR_PESQUISA.CONCORRENTE._text },
          EAN11: { _text: _returnResponse.S_CADASTRAR_PESQUISA.EAN11._text },
          GRUPO_CONCORRENTE: { _text: _returnResponse.S_CADASTRAR_PESQUISA.GRUPO_CONCORRENTE._text },
          MAKTX: { _text: _returnResponse.S_CADASTRAR_PESQUISA.MAKTX._text },
          MATNR: { _text: _returnResponse.S_CADASTRAR_PESQUISA.MATNR._text },
          MEINH: { _text: _returnResponse.S_CADASTRAR_PESQUISA.MEINH._text },
          PRECO_NOVO_AT: { _text: _returnResponse.S_CADASTRAR_PESQUISA.PRECO_NOVO_AT._text },
          PRECO_NOVO_VJ: { _text: _returnResponse.S_CADASTRAR_PESQUISA.PRECO_NOVO_VJ._text },
          PR_DIF: _prDif,
          TIPO: { _text: _returnResponse.S_CADASTRAR_PESQUISA.TIPO._text },
          WERKS: { _text: _returnResponse.S_CADASTRAR_PESQUISA.WERKS._text },
        };
      }
    }
  } catch (e) {
    console.log(e);
  } finally {
    return returnResponse;
  }
};

export default {
  getCodigoEAN,
};
